import { styled } from "@mui/material/styles";
import { Box, Typography, Card } from "@mui/material";
import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

/* // Styled Container */
export const StyledContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
}));

/* // Styled Card */
export const StyledCardBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  height: "auto",
  width: "100%",
  paddingLeft: theme.spacing(1),
  // marginLeft: theme.spacing(1),
  // [theme.breakpoints.down("xs")]: {
  //   flexDirection: "column",
  //   alignItems: "center",
  //   justifyContent: "center",
  //   width: "100%",
  //   height: "auto",
  //   paddingLeft: theme.spacing(0),
  //   marginLeft: theme.spacing(0),
  // },
  // [theme.breakpoints.up("sm")]: {
  //   flexDirection: "row",
  //   justifyContent: "space-around",
  //   width: "100%",
  //   height: "auto",
  //   paddingLeft: theme.spacing(1),
  //   marginLeft: theme.spacing(1),
  // },
  // [theme.breakpoints.up("md")]: {
  //   flexDirection: "row",
  //   justifyContent: "space-around",
  //   width: "100%",
  //   height: "auto",
  //   paddingLeft: theme.spacing(1),
  //   marginLeft: theme.spacing(1),
  // },
  // [theme.breakpoints.up("lg")]: {
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  //   width: "100%",
  //   height: "auto",
  //   paddingLeft: theme.spacing(1),
  //   marginLeft: theme.spacing(1),
  // },
  // [theme.breakpoints.up("xl")]: {
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  //   width: "100%",
  //   height: "auto",
  //   paddingLeft: theme.spacing(1),
  //   marginLeft: theme.spacing(1),
  // },
}));

export const StyledCard = styled(Card)(({ theme, selected }) => ({
  width: "80%",
  backgroundColor: selected
    ? getColor.SecondaryMidnightBlue
    : getColor.ExtendedPalettesSummerSkySS100,
  padding: theme.spacing("6px"),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 10,
  flexDirection: theme.breakpoints.up(800) ? "column" : "row",
  margin: theme.spacing("5px", "5px"),
  textAlign: "center",
}));

/* // Styled Question Typography */
export const StyledQuestion = styled(Typography)(({ theme }) => ({
  color: getColor.NeutralDark700,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: 700,
  padding: theme.spacing(2),
}));

/* // Styled Content Typography */
export const StyledContent = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.9rem",
  fontFamily: fonts.manrope,
  fontWeight: 600,
  width: "100%",
  textAlign: "center",
  textWrap: "balance",
  padding: "6px",
}));

// card typography
export const CardText = styled(Typography)(({ theme, selectedCardIndex }) => ({
  width: "100px",
  minWidth: "50px",
  color: selectedCardIndex
    ? getColor.PrimaryWhite
    : getColor.SecondaryMidnightBlue,
  backgroundColor: selectedCardIndex
    ? getColor.SecondaryMidnightBlue
    : getColor.ExtendedPalettesSummerSkySS100,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: "500",
  marginTop: "5px",
  padding: "5px",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  content: "open-quote",
  whiteSpace: "break-spaces",
}));

/* // Styled Button */
export const StyledButton = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "64%",
}));
export const AcrButton = {
  width: "80%",
  maxWidth: "350px",
  backgroundColor: getColor.ColorButtonPrimarysurface,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  p: "10px",
  mb: "20px",
  height: "60px",
  lineHeight: "22.2px",
  fontWeight: 700,
  fontSize: "16px",
  textAlign: "center",
  textTransform: "initial",
};
